import type { WhatsNewBody } from '../types';

export default {
  title: 'Feedback: see what others asked, and get replies by email',
  summary:
    'The 💬 Feedback button now tells you what happened to what you sent. My feedback shows your requests and any reply, Everyone’s feedback shows what others have asked so you can say Me too instead of sending a repeat, and you are emailed when a request you follow is answered or closed.',
  details: [
    'Click 💬 Feedback in the top bar and choose My feedback or Everyone’s feedback. A number on the button means something there is new for you.',
    'As you type a new request, Similar requests may appear under the box. If one is what you mean, press Me too.',
    'Admins read what you send first and may share it with everyone signed in. Your name is not shown with it, but tick Keep this private for anything sensitive.',
    'If two requests ask for the same thing, an admin combines them, and everyone who followed the duplicate follows the other one.',
  ],
  guide: { topic: 'send-feedback' },
} satisfies WhatsNewBody;
